import React from 'react';
import SeatingRenderer from './SeatingRenderer';
import './seating.scss';

const SeatingSelector = ({ eventId, cart, onSeatsSelected, onHoldTokenGenerated }) => (
  <div className="seating-selector">
    {/* Seating chart renderer */}
    <SeatingRenderer eventId={eventId} cart={cart} onSeatsSelected={onSeatsSelected} onHoldTokenGenerated={onHoldTokenGenerated} />
  </div>
);

export default SeatingSelector;
